module.exports = __webpack_public_path__ + "9788f41e/img/google.68f3823e.svg";